import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 725,
  maxHeight: "90vh",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.large,
  color: theme.palette.custom.white,
  outline: "none",
  [theme.breakpoints.down("md")]: {
    width: 530,
  },
  [theme.breakpoints.down("sm")]: {
    width: 350,
  },
  [theme.breakpoints.down("xs")]: {
    width: 270,
  },
}));

export const ModalHeader = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  padding: "24px",
  display: "flex",
  justifyContent: "space-between",
  flexShrink: 0,
  borderTop: `1px solid ${theme.palette.divider}`,
  background: theme.palette.custom.white,
}));
export const CloseBtn = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.blackColor,
  cursor: "pointer",
}));
export const StyledBoxCard = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.primary,
  display: "flex",
  padding: "13px 25px",
  alignItems: "center",
  flexShrink: 0,
  borderTopRightRadius: theme.borderRadius.radius.large,
  borderTopLeftRadius: theme.borderRadius.radius.large,
}));
export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontSize: theme.typography.large.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,

  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.base.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.regular.fontSize,
  },
}));
export const StyledBoxFlex = styled(Box)(() => ({
  display: "flex",
  gap: "6px",
  width: "100%",
  alignItems: "center",
}));

export const StyledTypographyGroupCart = styled(Typography)(
  ({ theme, isactive, isgap }) => ({
    color: theme.palette.custom.lockerValueColor,
    fontWeight: isactive ? "" : theme.typography.fontWeight.semiBold,
    fontSize: theme.typography.base.fontSize,
    marginBottom: !isgap && "18px",
    [theme.breakpoints.down("xs")]: {
      fontSize: theme.typography.mini.fontSize,
    },
  })
);
export const StyledTypographyLabel = styled(Typography)(
  ({ theme, isactive, color }) => ({
    color: color
      ? theme.palette.custom.notProvide
      : theme.palette.custom.lockerValueColor,
    fontWeight: isactive ? "" : theme.typography.fontWeight.medium,
    fontSize: theme.typography.base.fontSize,
    [theme.breakpoints.down("xs")]: {
      fontSize: theme.typography.mini.fontSize,
    },
  })
);
export const StyledBoxColorInfo = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.chatGroupDesBg,
  border: theme.borders.cardBorder,
  padding: "8px 16px",
  borderRadius: theme.borderRadius.radius.wallet,
}));
export const StyledBoxBorder = styled(Box)(({ theme }) => ({
  border: "1px solid  #FFD9AF",
  padding: "12px 16px",
  borderRadius: theme.borderRadius.radius.wallet,
}));
export const StyledFlexBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
}));
export const StyledBoxButton = styled(Box)(() => ({
  marginTop: "24px",
  position:"relative",
  // display:"inline-flex",
  width:"100%"
}));
